<template>
	<quiz></quiz>
	<utils></utils>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import Utils from './Utils.vue'
import Quiz from './components/views/skill-assessment/Quiz.vue'

export default defineComponent({
	name: 'SkillAssessmentApp',
	components: {
		Utils, Quiz
	}
})
</script>

<style scoped>

</style>
